import Vue from 'vue'
import Element from 'element-ui'
import theme from '@/mixins/theme.js'
import '@/styles/public.scss'
import emitter from '@/mixins/emitter.js'

Vue.use(Element)
Vue.mixin(theme)
Vue.mixin(emitter)


// WEBPACK FOOTER //
// ./src/utils/plugins.js